"use client";

import Image from "next/image";
import { Carousel, Typography } from "@material-tailwind/react";
import { useEffect, useState } from "react";
import { typographyStyles } from "@/styles/typography";

const CLIENTS = [
  "/image/client1.webp",
  "/image/client2.webp",
  "/image/client3.webp",
  "/image/client4.webp",
  "/image/client5.webp",
];

const chunkArray = (array: string[], size: number) =>
  array.reduce(
    (acc, _, i) => (i % size === 0 ? [...acc, array.slice(i, i + size)] : acc),
    [] as string[][]
  );

export function Clients() {
  const [groupedClients, setGroupedClients] = useState<string[][]>([]);
  const [chunkSize, setChunkSize] = useState(8);

  // Responsive chunk calculation
  const updateGroup = () => {
    const width = window.innerWidth;
    let chunkSize = 8; // default
    if (width < 640) chunkSize = 2; // mobile
    else if (width <= 1024) chunkSize = 6; // tablet
    else chunkSize = 8; // desktop
    setChunkSize(chunkSize);
    setGroupedClients(chunkArray(CLIENTS, chunkSize));
  };

  useEffect(() => {
    updateGroup(); // initial load
    window.addEventListener("resize", updateGroup);
    return () => window.removeEventListener("resize", updateGroup);
  }, []);

  const getGapWithCheckSize = (size: number) => {
    if (size === 6 || size === 8) return "gap-8";
    if (size === 2) return "gap-14";
    if (size === 5) return "gap-10";
    return "gap-8";
  };

  return (
    <section className="px-8 py-28" id="clients">
      <div className="container mx-auto text-center">
        <Typography
          variant="h2"
          color="blue-gray"
          className={`mb-8 ${typographyStyles.h2}`}
        >
          พันธมิตร ร่วมธุรกิจประกันภัย
        </Typography>
        <div className="text-start">
          <Typography
            variant="paragraph"
            color="blue-gray"
            className={`mb-4 ${typographyStyles.paragraph}`}
          >
            บริษัทประกันภัย 36 บริษัท
          </Typography>
          <Typography
            variant="paragraph"
            color="blue-gray"
            className={`mb-4 ${typographyStyles.paragraph}`}
          >
            - ปัจจุบัน ศรีกรุงโบรคเกอร์
            ได้เข้าร่วมกับพาร์ทเนอร์ทางธุรกิจประกันภัย 36 บริษัท
            และบริษัทประกันชีวิต 8 บริษัท ชั้นนำของประเทศ
          </Typography>
          <Typography
            variant="paragraph"
            color="blue-gray"
            className={`mb-4 ${typographyStyles.paragraph}`}
          >
            - สำหรับสมาชิกนายหน้าประกันภัย
            ที่สมัครร่วมธุรกิจสามารถส่งงานขายประกันรถยนต์ได้ทุกบริษัทประกันภัย
            และทุกบริษัทประกันชีวิต
            สามารถเปรียบเทียบประกันรถยนต์ได้หลายหลายบริษัท
            เป็นทางเลือกในการเสนอขายประกันรถยนต์และขายสินค้าประกันภัยให้กับลูกค้าได้อย่างเหมาะสม
          </Typography>
          <Typography
            variant="paragraph"
            color="blue-gray"
            className={`mb-4 ${typographyStyles.paragraph}`}
          >
            - สำหรับสมาชิกลูกค้า สามารถตัดสินใจเลือกซื้อสินค้าประกันภัย
            และสินค้าประกันชีวิต กับบริษัทประกันภัยได้หลากหลายบริษัท
            ตามราคาที่เหมาะสมสำหรับตัวเอง
          </Typography>
        </div>
        <Carousel
          className="overflow-hidden"
          loop
          autoplay
          transition={{ duration: 2.5 }}
        >
          {groupedClients.map((group, index) => (
            <div
              key={index}
              className={`flex justify-start items-center ${getGapWithCheckSize(
                chunkSize
              )} max-w-full`}
            >
              {group.map((logo, idx) => (
                <Image
                  key={idx}
                  alt={`client-${idx}`}
                  width={150}
                  height={150}
                  className="w-32 h-auto rounded"
                  src={logo}
                />
              ))}
            </div>
          ))}
        </Carousel>
      </div>
    </section>
  );
}

export default Clients;
